module.exports = __webpack_public_path__ + "static/media/gongcheng5.08a4caed.png";